import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Loader2, Sparkles } from 'lucide-react'
import { exchangeApiKeyForSession, fetchApi } from '../lib/api'
import { useAuthStore } from '../store/auth'

export function AuthCallbackPage() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const setAuthenticated = useAuthStore((s) => s.setAuthenticated)
  const setApiKey = useAuthStore((s) => s.setApiKey)
  const [status, setStatus] = useState('Completing login...')
  const [error, setError] = useState<string | null>(null)

  const code = searchParams.get('code')
  const state = searchParams.get('state')

  useEffect(() => {
    async function exchange() {
      if (!code || !state) {
        setError('Faltan parámetros de autorización. Intenta de nuevo.')
        return
      }

      try {
        const redirectUri = `${window.location.origin}/auth/callback`
        const res = (await fetchApi('/v1/auth/orzatty/exchange', {
          method: 'POST',
          body: JSON.stringify({ code, state, redirect_uri: redirectUri }),
        })) as { api_key: string }

        await exchangeApiKeyForSession(res.api_key)
        setApiKey(res.api_key)
        setAuthenticated(true)
        setStatus('Login exitoso. Redirigiendo...')
        navigate('/', { replace: true })
        window.location.reload()
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Error completando el login con Orzatty')
      }
    }

    exchange()
  }, [code, state, navigate, setAuthenticated])

  return (
    <div className="flex min-h-screen items-center justify-center bg-surface px-4">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-panel p-8 text-center shadow-2xl">
        <div className="mb-6 flex justify-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-brand-500 to-brand-700 shadow-lg shadow-brand-500/25">
            <Sparkles className="h-7 w-7 text-white" />
          </div>
        </div>

        {error ? (
          <>
            <h1 className="mb-2 text-xl font-bold text-red-400">Error de login</h1>
            <p className="text-sm text-gray-400">{error}</p>
            <button
              onClick={() => navigate('/login', { replace: true })}
              className="mt-6 rounded-lg bg-brand-600 px-4 py-2 text-sm font-semibold text-white hover:bg-brand-500"
            >
              Volver al login
            </button>
          </>
        ) : (
          <>
            <div className="mb-4 flex justify-center">
              <Loader2 className="h-8 w-8 animate-spin text-brand-500" />
            </div>
            <h1 className="mb-2 text-xl font-bold">{status}</h1>
            <p className="text-sm text-gray-400">Estamos conectando tu cuenta de Orzatty.</p>
          </>
        )}
      </div>
    </div>
  )
}
